import * as React from 'react';
import {
    getTypeLabelFromSearchResultType,
    SearchResultType,
} from '../../actions/user/resultTypeLabelActions';

import styles from './typeLabel.scss';

export const TypeLabel = (props: {
    resultType: SearchResultType;
    onClick: (resultType: SearchResultType) => void;
}) => {
    const typeLabel = getTypeLabelFromSearchResultType(props.resultType);
    if (!typeLabel) {
        return null;
    }
    return (
        <button
            className={styles.typeLabel}
            /* TODO: Task 254896: Renable click actions on Type Labels after filter options have been aligned with design
            onClick={e => {
                e.stopPropagation();
                props.onClick(props.resultType);
            }}
            */
        >
            {typeLabel}
        </button>
    );
};
